import MaterialTable from 'material-table';
import React, { Component } from 'react';
import "tabler-react/dist/Tabler.css";import { Icon } from "tabler-react";
import { forwardRef } from 'react';

import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Search from '@material-ui/icons/Search';

const tableIcons = {
	FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
	LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
	NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
	ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
	SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
};

class TablaRiesgo extends Component {
	/*Inicializamos todas las variables*/
	constructor (props) {
		super(props);
		this.state = {
			tablaRiesgo: [],
			updateTablaRiesgo: []
		};
	}

	componentDidUpdate = (prevProps) => {
		if(prevProps != this.props){
			if(this.props.data.tablaRiesgo != prevProps.data.tablaRiesgo){
				this.setState({tablaRiesgo: this.props.data.tablaRiesgo})
			}
			if(this.props.data.updateTablaRiesgo != prevProps.data.updateTablaRiesgo){
				this.setState({tablaRiesgo: this.props.data.updateTablaRiesgo})
			}
		}
	}

	render() {
		return (
			<>
				{/* Validando BlackBoard*/}
				{ this.props.data.blackboard.isBlackboard === true ? (
					<div class="row">
						<div class="col-md-3"></div>
						<div class="col-md-6" style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '40vh'}}>
							<span>Próximamente para Blackboard</span>
						</div>
						<div class="col-md-3"></div>
					</div>
				):(
					<MaterialTable
						title=""
						icons={tableIcons}
						columns={[
							{ title: 'Matrícula', field: 'matricula' },
							{ title: 'Nombre', field: 'nombre' },
							{ title: 'Apellidos', field: 'apellidos' },
							{ title: 'Nivel', field: 'nivel' },
							{ title: 'Grupo', field: 'grupo'},
							{ title: 'Estatus académico', field: 'estatusAcademico'},
							// { title: 'Estatus plataforma', field: 'estatusPlataforma'},
							{ title: 'Materias Aprobadas', field: 'materiasAprobadas'},
							{ title: 'Materias Reprobadas', field: 'materiasReprobadas'},
							{ title: 'Adeudos', field: 'riesgoAdeudos', hidden: true},
							{ title: 'Riesgo Acádemico', field: 'riesgoAcademico', render: rowData => <Icon prefix="fe" name={rowData.riesgoAcademico} />},
							{ title: 'Riesgo Final', field: 'riesgoFinal', render: rowData => <Icon prefix="fe" name={rowData.riesgoFinal} />},

						]}
						data={this.state.tablaRiesgo }     
						options={{
							headerStyle: {
								borderBottom: '2px solid #FF6F00',
							},
							rowStyle: {
								backgroundColor: '#f7f7f7',
							},
							draggable: false,
							pageSize: 10,
							pageSizeOptions: [10, 20],
						}}
						localization={{
							body: {
								emptyDataSourceMessage: 'Sin resultados'
							},
							toolbar: {
								searchTooltip: 'Buscar',
								searchPlaceholder: 'Buscar...',
								nRowsSelected: '{0} fila(s) seleccionada(s)'
							},
							pagination: {
								labelRowsSelect: 'filas',
								labelDisplayedRows: '{count} de {from}-{to}',
								firstTooltip: 'Primera página',
								previousTooltip: 'Página anterior',
								nextTooltip: 'Próxima página',
								lastTooltip: 'Última página'
							}
						}}
					/>
				)
				}
			</>
		)
	}
}

export default TablaRiesgo;